import ProxyCheckerSingleResult from './ProxyCheckerSingleResult'
export default ProxyCheckerSingleResult
